import React from "react";

const EnterCodeModal = ({
  isOpen,
  onClose,
  inviteCode,
  setInviteCode,
  onPasteCode,
  onJoinWithCode,
  isJoiningCode,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/50 z-[100] flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-6 md:p-8 animate-in zoom-in-95 duration-200 border border-gray-100">
        <div className="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center text-xl mb-4">
          <i className="fa-solid fa-key"></i>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-1">Enter Group Code</h3>
        <p className="text-sm text-gray-500 mb-5">
          Paste the invite code shared by your classmate to request joining their group.
        </p>

        <div className="relative mb-6">
          <input
            type="text"
            value={inviteCode}
            onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
            placeholder="e.g. GROUP-ABC123"
            className="w-full px-4 py-3.5 pr-20 rounded-xl border border-gray-200 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition font-mono font-bold tracking-wider text-base text-gray-800 bg-gray-50 focus:bg-white"
            autoFocus
          />
          <button
            type="button"
            onClick={onPasteCode}
            className="absolute right-2.5 top-1/2 -translate-y-1/2 px-2.5 py-1.5 rounded-lg text-xs font-bold text-blue-600 bg-blue-50 hover:bg-blue-100 transition"
          >
            Paste
          </button>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 rounded-xl font-bold text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isJoiningCode || !inviteCode.trim()}
            onClick={onJoinWithCode}
            className={`flex-1 py-3 rounded-xl font-bold text-sm text-white transition shadow-sm flex items-center justify-center gap-2 ${
              isJoiningCode || !inviteCode.trim()
                ? "bg-blue-300 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {isJoiningCode ? (
              <>
                <i className="fa-solid fa-circle-notch fa-spin text-xs"></i>
                <span>Joining...</span>
              </>
            ) : (
              <span>Request to Join</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnterCodeModal;
